import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconLayoutLeft: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-0-stroke-1.5-IconLayoutLeft"><Path d="M7.75 3C7.55109 3 7.36038 3.07907 7.21973 3.21973C7.07907 3.36038 7 3.55109 7 3.75V20.25C7 20.6642 7.33579 21 7.75 21H20.25C20.4489 21 20.6396 20.9209 20.7803 20.7803C20.9209 20.6396 21 20.4489 21 20.25V3.75C21 3.33579 20.6642 3 20.25 3H7.75Z" fill="currentColor"/><Path d="M3.75 3C3.33579 3 3 3.33579 3 3.75V20.25C3 20.6642 3.33579 21 3.75 21C4.16421 21 4.5 20.6642 4.5 20.25V3.75C4.5 3.33579 4.16421 3 3.75 3Z" fill="currentColor"/></CentralIconBase>;
});

export default IconLayoutLeft;
